import { Store } from 'lucide-react';
import { brand } from '@/config/brand';
import { Button } from '@/ui/core';
import { useConfirm } from '@/ui/overlay';
import { useSession } from './providers';

/** Asks once, then opens the real counts (set them up, or join, if this device hasn't yet). */
export function useLeavePractice(): () => Promise<void> {
  const { switchMode } = useSession();
  const confirm = useConfirm();
  return async () => {
    const ok = await confirm({
      title: `Go to ${brand.business}’s real counts?`,
      body: 'The practice numbers stay in Practice. If this device isn’t set up for the real counts yet, that comes next: set it up, or join a tablet or phone that already is.',
      confirmLabel: 'Go to the real counts',
    });
    if (ok) switchMode('reds');
  };
}

/** The way out of Practice, on the yellow Practice notices. */
export function LeavePracticeButton() {
  const leave = useLeavePractice();
  return (
    <Button variant="primary" icon={<Store className="size-4" aria-hidden />} onClick={() => void leave()}>
      Go to the real counts
    </Button>
  );
}
